import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_ed61a952 from 'nuxt_plugin_plugin_ed61a952' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_e90a389e from 'nuxt_plugin_sentryserver_e90a389e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_25c17229 from 'nuxt_plugin_sentryclient_25c17229' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginutils_315b3624 from 'nuxt_plugin_pluginutils_315b3624' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_124d6eb9 from 'nuxt_plugin_pluginrouting_124d6eb9' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2578c154 from 'nuxt_plugin_pluginmain_2578c154' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_047ff78e from 'nuxt_plugin_image_047ff78e' // Source: ./nuxt-spoferan/plugins/image.js (mode: 'all')
import nuxt_plugin_date_27100f12 from 'nuxt_plugin_date_27100f12' // Source: ./nuxt-spoferan/plugins/date.js (mode: 'all')
import nuxt_plugin_routes_6c19504a from 'nuxt_plugin_routes_6c19504a' // Source: ./nuxt-spoferan/plugins/routes.js (mode: 'all')
import nuxt_plugin_ads_1b717899 from 'nuxt_plugin_ads_1b717899' // Source: ./nuxt-spoferan/plugins/ads.js (mode: 'all')
import nuxt_plugin_gtm_268d4a29 from 'nuxt_plugin_gtm_268d4a29' // Source: ./nuxt-spoferan/plugins/gtm.js (mode: 'all')
import nuxt_plugin_gtm_4e1c7f03 from 'nuxt_plugin_gtm_4e1c7f03' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_cbe33e26 from 'nuxt_plugin_axios_cbe33e26' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_polyfill_4efc87d1 from 'nuxt_plugin_polyfill_4efc87d1' // Source: ./spoferan-ui/plugins/polyfill.js (mode: 'client')
import nuxt_plugin_detector_7b9d600c from 'nuxt_plugin_detector_7b9d600c' // Source: ./spoferan-ui/plugins/detector.js (mode: 'all')
import nuxt_plugin_breakpoints_45408028 from 'nuxt_plugin_breakpoints_45408028' // Source: ./spoferan-ui/plugins/breakpoints.js (mode: 'all')
import nuxt_plugin_trans_46f6a134 from 'nuxt_plugin_trans_46f6a134' // Source: ./spoferan-ui/plugins/trans.js (mode: 'all')
import nuxt_plugin_spoferan_3a335b9c from 'nuxt_plugin_spoferan_3a335b9c' // Source: ./spoferan-ui/plugins/spoferan.js (mode: 'all')
import nuxt_plugin_config_3fddc0bf from 'nuxt_plugin_config_3fddc0bf' // Source: ../src/plugins/config.js (mode: 'all')
import nuxt_plugin_plugin_63324869 from 'nuxt_plugin_plugin_63324869' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_7785c9c7 from 'nuxt_plugin_auth_7785c9c7' // Source: ../node_modules/nuxt-spoferan/src/plugins/auth.js (mode: 'all')
import nuxt_plugin_axios_05a1f249 from 'nuxt_plugin_axios_05a1f249' // Source: ../node_modules/nuxt-spoferan/src/plugins/axios.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"de"},"title":"SPOFERAN Pressebereich - Unternehmensportrait, Pressemitteilungen und Downloads","titleTemplate":"%s | SPOFERAN Pressebereich","meta":[{"charset":"utf-8"},{"name":"viewport","content":"height=device-height, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0"},{"hid":"description","name":"description","content":"Erfahre alles über die Gründungsidee SPOFERAN, die ersten Schritte, das Unternehmen und die Gründer."},{"name":"author","content":"SPOFERAN GmbH"},{"name":"theme-color","content":"#008200"},{"property":"og:title","content":"SPOFERAN Pressebereich - Unternehmensportrait, Pressemitteilungen und Downloads","hid":"og:title"},{"property":"og:type","content":"website","hid":"og:type"},{"property":"og:site_name","content":"SPOFERAN Pressebereich - Unternehmensportrait, Pressemitteilungen und Downloads"},{"property":"og:description","content":"Erfahre alles über die Gründungsidee SPOFERAN, die ersten Schritte, das Unternehmen und die Gründer.","hid":"og:description"},{"property":"og:image","content":"https:\u002F\u002Fcdn.spoferan.com\u002Fimages\u002Fspoferan-feature-image.jpg","hid":"og:image"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"apple-mobile-web-app-capable","content":"yes"}],"link":[{"rel":"shortcut icon","type":"image\u002Fx-icon","hid":"x-icon","href":"\u002Fimages\u002Ffavicons\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fpng","hid":"favicon-180","sizes":"180x180","href":"\u002Fimages\u002Ffavicons\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","hid":"favicon-32","sizes":"32x32","href":"\u002Fimages\u002Ffavicons\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","hid":"favicon-16","sizes":"16x16","href":"\u002Fimages\u002Ffavicons\u002Ffavicon-16x16.png"},{"rel":"mask-icon","type":"image\u002Fpng","hid":"mask-icon","color":"#008200","href":"\u002Fimages\u002Ffavicons\u002Fsafari-pinned-tab.svg"},{"src":"https:\u002F\u002Fuse.typekit.net\u002F","rel":"preconnect"},{"src":"https:\u002F\u002Fuse.typekit.net\u002F","rel":"dns-prefetch"},{"src":"https:\u002F\u002Fcdn.spoferan.com\u002F","rel":"preconnect"},{"src":"https:\u002F\u002Fcdn.spoferan.com\u002F","rel":"dns-prefetch"},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002F","rel":"preconnect"},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002F","rel":"dns-prefetch"}],"style":[],"script":[{"src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=IntersectionObserver","body":true,"nomodule":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NZQ79NH&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_ed61a952 === 'function') {
    await nuxt_plugin_plugin_ed61a952(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_e90a389e === 'function') {
    await nuxt_plugin_sentryserver_e90a389e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_25c17229 === 'function') {
    await nuxt_plugin_sentryclient_25c17229(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_315b3624 === 'function') {
    await nuxt_plugin_pluginutils_315b3624(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_124d6eb9 === 'function') {
    await nuxt_plugin_pluginrouting_124d6eb9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2578c154 === 'function') {
    await nuxt_plugin_pluginmain_2578c154(app.context, inject)
  }

  if (typeof nuxt_plugin_image_047ff78e === 'function') {
    await nuxt_plugin_image_047ff78e(app.context, inject)
  }

  if (typeof nuxt_plugin_date_27100f12 === 'function') {
    await nuxt_plugin_date_27100f12(app.context, inject)
  }

  if (typeof nuxt_plugin_routes_6c19504a === 'function') {
    await nuxt_plugin_routes_6c19504a(app.context, inject)
  }

  if (typeof nuxt_plugin_ads_1b717899 === 'function') {
    await nuxt_plugin_ads_1b717899(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_268d4a29 === 'function') {
    await nuxt_plugin_gtm_268d4a29(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4e1c7f03 === 'function') {
    await nuxt_plugin_gtm_4e1c7f03(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_cbe33e26 === 'function') {
    await nuxt_plugin_axios_cbe33e26(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfill_4efc87d1 === 'function') {
    await nuxt_plugin_polyfill_4efc87d1(app.context, inject)
  }

  if (typeof nuxt_plugin_detector_7b9d600c === 'function') {
    await nuxt_plugin_detector_7b9d600c(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoints_45408028 === 'function') {
    await nuxt_plugin_breakpoints_45408028(app.context, inject)
  }

  if (typeof nuxt_plugin_trans_46f6a134 === 'function') {
    await nuxt_plugin_trans_46f6a134(app.context, inject)
  }

  if (typeof nuxt_plugin_spoferan_3a335b9c === 'function') {
    await nuxt_plugin_spoferan_3a335b9c(app.context, inject)
  }

  if (typeof nuxt_plugin_config_3fddc0bf === 'function') {
    await nuxt_plugin_config_3fddc0bf(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_63324869 === 'function') {
    await nuxt_plugin_plugin_63324869(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7785c9c7 === 'function') {
    await nuxt_plugin_auth_7785c9c7(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_05a1f249 === 'function') {
    await nuxt_plugin_axios_05a1f249(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
